import Image from "next/image";

import { type FragmentOf, readFragment } from "~/lib/graphql";

import * as fragment from "./graphql";

export function SingleImage(props: {
  record: FragmentOf<typeof fragment.singleImageFragment>;
}) {
  const record = readFragment(fragment.singleImageFragment, props.record);

  return (
    <div className="singleimage container mx-auto my-10 max-w-[780px] px-4 lg:px-0">
      <Image
        src={`${record.image?.url}?w=800&h=600&fit=crop&crop=focalpoint&fp-x=${record.image?.focalPoint?.x}&fp-y=${record.image?.focalPoint?.y}&auto=format`}
        width={800}
        height={600}
        alt={record.image?.alt || record.image?.title || ""}
      />
    </div>
  );
}
